import { bankSearchComponent } from './bankSearch.component';
import { BankSearchService } from './bankSearch.service';
// Templates
import bankSearchSuggestTpl from './templates/bankSearchSuggest.html';


export default angular
  .module('ng1-bank-search', [])
  .component('bankSearch', bankSearchComponent)
  .service('bankSearchService', BankSearchService)
  .value('bankSearchSuggestTemplatePath', 'templates/bankSearchSuggest.html')
  .run(($templateCache, bankSearchSuggestTemplatePath) => {
    'ngInject';
    $templateCache.put(bankSearchSuggestTemplatePath, bankSearchSuggestTpl);
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-bank-search/src/index.js